import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';


@Pipe({
  name: 'translate',
  pure:false
})
export class TranslationPipe implements PipeTransform {
  constructor(private transService: TranslationService) {
  }
  transform(value: string, ...args: any[]): string {
    return this.transService.translate(value, ...args);
  }

}
